<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h1 class="mb-2">Enter Information</h1>
        <p class="text-body-1">{{ $t('mal_use_this_process_to_link_a_minors_account') }}</p>
        <p class="text-body-1">
          {{ $t('mal_please_enter_the_minors_info') }}
          <v-tooltip
            location="bottom"
            max-width="250"
            open-on-click
            :text="$t('mal_you_can_only_search_for_minor_account_as_custodian')"
          >
            <template #activator="{ props }">
              <v-icon
                aria-label="Help tooltip"
                :icon="mdiHelpCircle"
                size="x-small"
                v-bind="props"
              />
            </template>
          </v-tooltip>
        </p>
      </v-col>
      <v-col cols="12" sm="4" md="4" lg="4">
        <v-form
          ref="submit_minor_accounts"
          id="submit_minor_accounts"
          v-model="validForm"
          autocomplete="off"
        >
          <div class="d-flex flex-column">
            <OnexDatePicker
              id="birth_date"
              type="dob"
              v-model="birthDate"
              :date-format="dobFormatLanguage"
              :label="$t('mal_minors_date_of_birth')"
              :min="minDateCheck"
              required
              sensitive
            />
            <OnexSsn
              id="ssn"
              :format="SSNFormat.SSN"
              v-model="ssn"
              :lastFour="ssn"
              allow-sin-business
              allow-sin-itn
              data-comp-id="minor_ssn"
              :label="$t('mal_minors_ssn')"
              required
            />
          </div>
        </v-form>
      </v-col>
    </v-row>
    <v-row class="justify-end mt-4">
      <v-col cols="12" sm="4">
        <OnexButton
          :disabled="disableActions"
          block
          color="primary"
          variant="outlined"
          @click="cancelAction"
        >
          {{ $t('L_cancel') }}
        </OnexButton>
      </v-col>
      <v-col cols="12" sm="4">
        <OnexButton
          :disabled="disableActions || !(validForm && birthDate && ssn)"
          block
          color="primary"
          @click="continueAction"
        >
          {{ $t('L_continue') }}
        </OnexButton>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import {
  OnexDatePicker,
  OnexSsn,
  OnexButton,
  DateFormats,
  UILocale,
  SSNFormat,
} from '@primerica/onex-ui-lib';
import { mdiHelpCircle } from '@mdi/js';
import { minDateCheck } from '@/shared/utils/dateFormats';

const componentOptions: ComponentOptions = {
  name: 'MinorAccountLinkProcessEnterInformation',
  components: {
    OnexDatePicker,
    OnexSsn,
    OnexButton,
  },
  props: {
    disableActions: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    birthDate: '',
    ssn: '',
    minorInformationTooltip: false,
    showTooltip: false,
    validForm: false,
    mdiHelpCircle,
  }),
  computed: {
    minDateCheck,
    disableAccountHolderNameEdit() {
      return 0;
    },
    SSNFormat() {
      return SSNFormat;
    },
    dobFormatLanguage() {
      return this.$i18n.locale === UILocale.FR_CA.toString()
        ? DateFormats.DDMMYYYY
        : DateFormats.MMDDYYYY;
    },
  },
  methods: {
    continueAction() {
      this.$emit('continueClicked', { dob: this.birthDate, taxId: this.ssn });
    },
    cancelAction() {
      this.$emit('cancelClicked');
    },
  },
};

export default defineComponent(componentOptions);
</script>
